import { LotFields } from '../../../firebase/document-field.enums';
import { FilterModel } from './filter.model';
import { LotType } from '../type/lot.type';
import { FilterType } from './filter.type';
import { YES_NO_FILTER_OPTIONS } from './yes-no-filter-options';

const LOT_NAME_FILTER_FIELD = 'name';
const LOT_TYPE_FILTER_FIELD = 'lot_type';

export const LOT_LIST_FILTERS: FilterModel[] = [
  {
    fieldName: LOT_NAME_FILTER_FIELD,
    label: 'lots.fields.name',
    placeholder: 'lots.searchFilters.namePlaceholder',
    type: FilterType.text,
    value: '',
  },
  {
    fieldName: LOT_TYPE_FILTER_FIELD,
    label: 'lots.fields.kind',
    type: FilterType.select,
    options: Object.values(LotType).map((value) => ({ value, label: value })),
    value: '',
  },
  {
    fieldName: LotFields.permitted_to_scan_by_oova_app,
    label: 'lots.fields.permittedToScanByOovaApp',
    type: FilterType.radio,
    options: YES_NO_FILTER_OPTIONS,
    value: '',
  },
  {
    fieldName: LotFields.status,
    label: 'lots.fields.status',
    type: FilterType.select,
    options: [
      {
        label: 'lots.fields.statusValues.beta',
        value: 'Beta',
        translate: true,
      },
      {
        label: 'lots.fields.statusValues.validated',
        value: 'Validated',
        translate: true,
      },
      {
        label: 'lots.fields.statusValues.releasedForProd',
        value: 'Released for Production',
        translate: true,
      },
      {
        label: 'lots.fields.statusValues.live',
        value: 'Live',
        translate: true,
      },
      {
        label: 'lots.fields.statusValues.inDev',
        value: 'In development',
        translate: true,
      },
      {
        label: 'lots.fields.statusValues.archived',
        value: 'Archived',
        translate: true,
      },
      {
        label: 'lots.fields.statusValues.repurposed',
        value: 'Repurposed',
        translate: true,
      },
    ],
    value: '',
  },
];
